import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import NotFound from "./NotFound";
import data from "../data/data.js";
import { Button } from "flowbite-react";
import { Carousel } from "flowbite-react";
import PdpAccordion from "./PdpAccordion.js";
import "./Pdp.css";
import FormModal from "./FormModal";
import { useLocation } from 'react-router-dom';

const ProductDetail = () => {

  const { productName, subcategory } = useParams();
  const [openModal, setOpenModal] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState(null);
  const [indicator, Setindicator] = useState(true)

  const { pathname } = useLocation();

  function onCloseModal() {
    setOpenModal(false);
    setEmail("");
  }

  useEffect(() => {
    const findProduct = getProductByName(productName, subcategory)
    if (!findProduct) {
      setProduct(null);
    } else {
      setProduct(findProduct);
      if (findProduct.name === "Transformador" || findProduct.name === "Control de luz") {
        Setindicator(false)
      }
      setLoading(false);
    }
    window.scrollTo(0, 0);
  }, [productName, pathname]);

  if (loading) {
    return <p></p>;
  }
  if (!product) {
    return <NotFound />;
  }

  return (
    <section className="pdp-content">
      <div className="pdp-container">
        <section className="carousel-container">
          <div className="carousel-container-container">
            {product?.image && (
              <Carousel indicators={indicator}>
                {[
                  product.image,
                  ...(product.gallery ?? []),
                ]
                  .filter(Boolean)
                  .map((image, index) => (
                    <div
                      className="image-container"
                      key={`${image}-${index}`}
                    >
                      <img
                        src={image}
                        alt={product.name}
                        loading={index === 0 ? "eager" : "lazy"}
                      />
                    </div>
                  ))}
              </Carousel>
            )}
          </div>
        </section>
        <section className="pdp-details-container">
          <span className="pdp-text">
            {product.subcategory !== "vigas" && product.subcategory !== "esquineros" && product.subcategory !== "Iluminación y Colocación"
              && product.subcategory !== "Interior"
              && product.subcategory !== "Panel Liso Exterior"
              && product.subcategory !== "Accesorios"
              && product.subcategory !== "Deck Exteriores"
              && product.subcategory !== "Colocación Exteriores"
              && product.subcategory !== "Vigas Exterior"
               && product.subcategory !== "Deck Bicolor"
              ? `${product.category.toUpperCase()}
                Colección ${product.subcategory
                .split(" ")
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ")}`
              : product.category.toUpperCase() + " " + product.subcategory
                .split(" ")
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ")}
          </span>

          <h1 className="pdp-title">
            {productName}
          </h1>

          <article className="pdp-details">
            {product.size && <span className="pdp-text">{product.size + " "}</span>}
            <p className="pdp-accordion-text">{product.description}</p>

            <PdpAccordion product={product}></PdpAccordion>
            <article className="pdp-buttons">
              {product.datasheet &&
                <a className="product-button" href={require(`../assets/datasheet/${product.datasheet}.pdf`)} target="_blank" rel="noopener noreferrer">
                  Ficha Técnica
                </a>
              }
              <Button
                className="product-button"
                onClick={() => setOpenModal(true)}
              >
                Realizar Pedido
              </Button>
              <FormModal
                openModal={openModal}
                onCloseModal={onCloseModal}
                email={email}
                setEmail={setEmail}
              ></FormModal>
            </article>

            {product.subcategory !== "Iluminación" && product.subcategory !== "Vigas y Esquineros" && <span className="text-small">
              Te recomendamos agregar un 10% extra al total de tu pedido,
              esto por temas de corte y pedacería que puedan surgir en la
              instalación.
            </span>}
          </article>
        </section>
      </div>
    </section>
  );
};

const getProductByName = (productName, subcategory) => {
  let result = data.products.filter((items) => items.subcategory === subcategory);
  result = result.find((product) => product.name === productName);
  return result;
};


export default ProductDetail;